export default "/images/horizontal.svg?e529c357ea13622ca1e58b5536008126";